import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useContext } from "react";
import { useState } from "react";
// import { InVoiceContext } from "./InvoiceTable";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { EditorState, convertFromHTML, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const useStyles = makeStyles((theme) => ({
  title: {
    marginBottom: -20,
  },
  border: {
    width: 205,
    float: "right",
    marginTop: -11,
  },
  content: {
    background: "white",
    color: "black",
  },
  customTableCell: {
    color: "black",
  },
}));

const Invoice = (props) => {
  // const [showInvoice, setShowInvoice, invoiceType] = useContext(InVoiceContext);
  const [isToolbarHidden, setIsToolbarHidden] = useState(true);

  const classes = useStyles(props);
  const data = [
    {
      srNo: 1,
      refNo: 361057901,
      Reference: "HT018301-NK -IN-12022347Q0012(RET)(MISSING)",
      Description: "Kitchen Cabinets",
      hSCode: 94657300,
      countryOfOrigin: "Germany",
      qty: 4,
      noOfPkts: 1,
      amount: 23878,
    },
    {
      srNo: 2,
      refNo: 361057901,
      Reference: "HT018301-NK -IN-12022347Q0012(RET)(MISSING)",
      Description: "Kitchen Cabinets",
      hSCode: 94657300,
      countryOfOrigin: "Germany",
      qty: 1,
      noOfPkts: 1,
      amount: 1265,
    },
  ];

  const total = (items) => {
    return items.map(({ amount }) => amount).reduce((sum, i) => sum + i, 0);
  };
  const quantity = (items) => {
    return items.map(({ qty }) => qty).reduce((sum, i) => sum + i, 0);
  };

  const [editorState, setEditorState] = useState(() => {
    const initialContent = ``;

    const blocksFromHTML = convertFromHTML(initialContent);

    const contentState = ContentState.createFromBlockArray(
      blocksFromHTML.contentBlocks,

      blocksFromHTML.entityMap
    );

    return EditorState.createWithContent(contentState);
  });

  const onEditorStateChange = (newEditorState) => {
    setEditorState(newEditorState);
    setIsToolbarHidden(false);
  };

  const handleEditerBlur = () => {
    setIsToolbarHidden(true);
  };

  return (
    <div>
      <Dialog
        open={showInvoice}
        onClose={() => setShowInvoice(false)}
        fullWidth={true}
        maxWidth={"lg"}
      >
        <DialogContent className={classes.content}>
          <div>
            <div className="flex w-full sm:w-auto justify-end">
              <Button
                onClick={() => {
                  setShowInvoice(false);
                }}
              >
                <FuseSvgIcon className="">heroicons-solid:x</FuseSvgIcon>
              </Button>
            </div>
            <Editor
              toolbarHidden={isToolbarHidden}
              toolbarOnFocus
              onBlur={handleEditerBlur}
              editorState={editorState}
              toolbarClassName="toolbarClassName"
              wrapperClassName="wrapperClassName"
              editorClassName="editorClassName"
              onEditorStateChange={onEditorStateChange}
              // onContentStateChange={onContentStateChange}
            />
            <DialogTitle
              className={clsx(
                classes.title,
                " text-right text-8xl font-black "
              )}
            >
              nolte
            </DialogTitle>
            <div
              className={clsx(
                classes.border,
                "grid grid-cols-1 border-b-8 border-solid border-yellow-800 "
              )}
            ></div>
            <Typography className=" text-right text-3xl font-bold ">
              FZE
            </Typography>
            <DialogContentText
              id="alert-dialog-description"
              className={classes.content}
            >
              <div>
                <Typography className=" text-right text-1xl font-bold ">
                  NOLTE FZE
                  <br />
                  Dubai Silicon Oasis HQ,
                  <br />
                  Office : 404-405,E-Wing,
                  <br />
                  P.O.Box No.341265 , Dubai , UAE
                  <br />
                </Typography>
              </div>
            </DialogContentText>
          </div>

          {/* </DialogContent>
                <DialogContent className={classes.content}> */}
          <div>
            <Typography className=" text-center text-3xl font-bold ">
              {invoiceType}
            </Typography>
          </div>
          {/* </DialogContent>
                <DialogContent className={classes.content}> */}
          <Grid container spacing={2} marginBottom={5}>
            <Grid item xs={6}>
              <Typography className="">
                HBI CO.LTD
                <br />
                1F, No.260, Tun Hua N.Road
                <br />
                R.O.C
                <br />
                P.O.Box No.
                <br />
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography className=" text-right">
                Invoice No. : GI-23060020
                <br />
                Date : 11-09-2023
                <br />
                Terms of Delivery : Ex Works
                <br />
                Payment term : LC at 120 days
              </Typography>
            </Grid>
          </Grid>
          <TableContainer
            component={Paper}
            sx={{ border: "1px solid gray", borderRadius: 0 }}
            className={classes.content}
          >
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell className={classes.customTableCell}>
                    Sr No.
                  </TableCell>
                  <TableCell className={classes.customTableCell}>
                    Ref No.
                  </TableCell>
                  <TableCell className={classes.customTableCell}>
                    Reference
                  </TableCell>
                  <TableCell className={classes.customTableCell}>
                    Description
                  </TableCell>
                  <TableCell className={classes.customTableCell}>
                    HSCode
                  </TableCell>
                  <TableCell className={classes.customTableCell}>
                    CountryOfOrigin
                  </TableCell>
                  <TableCell className={classes.customTableCell}>Qty</TableCell>
                  <TableCell className={classes.customTableCell}>
                    No Of Pkts
                  </TableCell>
                  <TableCell className={classes.customTableCell}>
                    Amount
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map((row) => (
                  <TableRow>
                    <TableCell
                      className={classes.customTableCell}
                      component="th"
                      scope="row"
                    >
                      {row.srNo}
                    </TableCell>
                    <TableCell className={classes.customTableCell}>
                      {row.refNo}
                    </TableCell>
                    <TableCell className={classes.customTableCell}>
                      {row.Reference}
                    </TableCell>
                    <TableCell className={classes.customTableCell}>
                      {row.Description}
                    </TableCell>
                    <TableCell className={classes.customTableCell}>
                      {row.hSCode}
                    </TableCell>
                    <TableCell className={classes.customTableCell}>
                      {row.countryOfOrigin}
                    </TableCell>
                    <TableCell className={classes.customTableCell}>
                      {row.qty}
                    </TableCell>
                    <TableCell className={classes.customTableCell}>
                      {row.noOfPkts}
                    </TableCell>
                    <TableCell className={classes.customTableCell}>
                      {row.amount}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell rowSpan={1} />
                  <TableCell
                    className={classes.customTableCell}
                    colSpan={4}
                  ></TableCell>
                  <TableCell className={classes.customTableCell}>
                    Total
                  </TableCell>
                  <TableCell className={classes.customTableCell}>
                    {quantity(data)}
                  </TableCell>
                  <TableCell className={classes.customTableCell}></TableCell>
                  <TableCell className={classes.customTableCell}>
                    {total(data)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Typography className="my-16">
            Amount in words : twenty-five thousand one hundred forty-three only
          </Typography>

          <Typography className="font-bold">
            Container Number : TCLU3171746
            <br />
            LC No. : 3AQQH2001719
          </Typography>
          <div className="flex justify-end">
            <div>
              <Button variant="contained" color="warning" className="mr-16">
                <Typography color="black">Send Invoice</Typography>
              </Button>
            </div>
            <div>
              <Button variant="contained" color="warning">
                <Typography color="black">Download Invoice</Typography>
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Invoice;
